import { useContext } from "react";

import { CloudFileDashboardContext } from "./CloudFileDashboardContext";

export const useCloudFileDashboard = (): CloudFileDashboardContext => useContext(CloudFileDashboardContext);
